export default __webpack_public_path__ + "static/media/UploadDocument.a32a910e.svg";